import React from "react";
import ProductDetails from "./product_details/ProductDetails";
import Explore_Other_Products from "./Explore_Other_Products/Explore_Other_Products";
import ExperiencePower from "../../../../../gallary_showcase/experience_power/ExperiencePower";
import EffectSwiper from "./our_category_effects_Swiper/EffectSwiper";
import HaveQuestion from "../../have_question/HaveQuestion";

export default function ProductInner() {
  return (
    <div>
      <ProductDetails />
      <Explore_Other_Products />
      <ExperiencePower />
      <EffectSwiper />
      <HaveQuestion />
    </div>
  );
}
